<template>
	<div v-if="links.length > 3">
		<div v-if="!isApi" class="-mb-1 flex flex-wrap">
			<template v-for="(link, key) in links">
				<div
					v-if="link.url === null"
					:key="key"
					class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 text-gray-400"
					v-html="link.label"
				/>

				<Link
					v-else
					:key="`link-${key}`"
					class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 hover:bg-white focus:border-indigo-500 focus:text-indigo-500"
					:class="{ 'bg-white': link.active }"
					:href="link.url"
					v-html="link.label"
				/>
			</template>
		</div>
		<div v-else class="-mb-1 flex flex-wrap">
			<div
				class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 text-gray-400 cursor-pointer"
				v-html="'Föregående'"
				@click="paginate('prev')"
			/>

			<template
				v-for="(link, key) in links"
				:key="`api-${ key }`"
			>
				<span
					v-html="link.label"
					class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 hover:bg-white cursor-pointer"
					:class="{ 'bg-[#1d3557] text-white': link.active }"
					@click="apiCallback(link.label)"
				>
				</span>
			</template>

			<div
				class="mb-1 mr-1 rounded border px-4 py-3 text-sm leading-4 text-gray-400 cursor-pointer"
				v-html="'Nästa'"
				@click="paginate('next')"
			/>
		</div>
	</div>
</template>

<script>
	import { computed } from 'vue'
	import { Link } 	from '@inertiajs/inertia-vue3'

	export default {
		components: {
			Link
		},
		props: {
			links: Array,
			isApi: {
				type: Boolean,
				default: false
			},
			apiCallback: Function
		},
		setup(props) {
			const links = computed(() => {
				const links = [ ...props.links ]

				if (props.isApi) {
					links.shift()
					links.pop()
				}

				return links
			})

			const paginate = (type) => {
				const currentPage = links.value.find(l => l.active === true)?.label
				const nextPage = type === 'next'
					? Number(currentPage) + 1
					: Number(currentPage) - 1

				if (type === 'next' && nextPage <= links.value.length) {
					props.apiCallback({ page: nextPage })
				}

				if (type === 'prev' && nextPage > 0 && nextPage < links.value.length) {
					props.apiCallback({ page: nextPage })
				}
			}

			return {
				links,
				paginate
			}
		}
	}
</script>
